import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { UserListComponent } from './users/user-list/user-list.component';
import { MenuComponent } from './layout/menu/menu.component';
import { LayoutComponent } from './layout/layout.component';


const routes: Routes = [
    {
        path: 'users',
        component : UserListComponent,
    },
    {
    path: '',
    component :  LayoutComponent,
    },
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/app.routing.ts